'use strict';

(function (global) {

  // Стандартный отступ плейсхолдеров
  const PLACEHOLDER_MARGIN = 20;

  // Способы масштабирования области предпросмотра
  const PREVIEW_SCALE = {
    FIT_HEIGHT: 'h',
    FIT_WIDTH: 'w',
    FIT_WINDOW: 'a',
  };

  /**
* Объект цикличный-итератор по направлениям вращения по сторонам света
* @object Directions
* @since 5.1.0.1523
*/
  const Directions = {
    index: 0,
    directions: ['N', 'E', 'S', 'W'],
    next: function () {
      this.index = (this.index === this.directions.length - 1) ? 0 : ++this.index;
      return this.directions[this.index];
    },
    prev: function () {
      this.index = this.index ? --this.index : (this.directions.length - 1);
      return this.directions[this.index];
    },
  };

  /**
  * Базовый класс для действий над изображениями.
  * (Поворот, масштабирование и прокрутка)
  *
  * @since 5.8.0
  */
  class ImageActions extends global.BaseActions {

    constructor(context) {
      super();
      this._settings = new global.ImageDocumentPreviewSettings();
      this._initAttributes(context);
      this.postInit();
    }

    /**
    * @see Core.preview.BaseActions._initAttributes
    */
    _initAttributes(context) {
      super._initAttributes(context);
      this._html = this._jFrameContents.find('html');
      this._jCanvas = this._jFrameContents.find('canvas').first();
      this._jPlaceholder = this._jFrameContents.find('.placeholder');
      this._placeholderMargin = PLACEHOLDER_MARGIN;
      this._imageInitialSize = {
        height: +(this._jCanvas.attr('naturalHeight') || this._jCanvas.height()),
        width: +(this._jCanvas.attr('naturalWidth') || this._jCanvas.width()),
      };
      this._recalculateContainerSize();

      this._data = context;
      this._pageCount = context.convertedObj ? context.convertedObj.pageCount : 1;
      this._pagesIterator = 2;
      this._jPageNumber = $('.page-number-field');
      this._isCallJumpToPage = false;
      this._scaleKey = this.settings.previewScale;
      this._scale = this._getScale(this._scaleKey);
      this._direction = '';
    }

    /**
     * Подгрузка стилей и изменение страницы для адаптации под прокрутку.
     * @function Core.preview.actions.init
     * @since 5.1.0.1523
     * @return {Core.preview.actions}
     */
    postInit() {
      log.info('PREVIEW', 'Preview frame loaded successfully');
      this._setScaleValueInDropdownAndButtons(this._scaleKey);
      this.href = `${this._data.previewHandlerUrl}/${this._data.convertedObj.id}/{0}`;

      this.prepareFirstImage().done(scrolling => {
        scrolling
          .fillWithPlaceHolders()
          .attachToFrameScrolling()
          ._actualizePages();

        Core.preview.dispatchFrameReadyEvent();

        // Прячем блок, экранирующий область предпросмотра (тулбар предпросмотра и iframe с загруженным документом)
        Core.preview._hideOverlay();
      });

      const jBody = this._jFrameContents.find('body');
      jBody[0].classList = [];
      jBody.addClass('image');

      return this;
    }

    /**
     * Первая картинка грузится всегда, она опорная точка, с нее
     * снимаются все параметры. Её-же мы делаем похожей на все остальные.
     * @function Core.preview.actions.prepareFirstImage
     * @return {Deferred}
     * @since 5.1.0.1523
     */
    prepareFirstImage() {
      log.info('PREVIEW', 'Preparing first image');

      const d = $.Deferred();

      Core.preview._drawImageInCanvas(1, this._direction, this._scale, true).done(() => {

        this._width = this._jCanvas.prop('naturalWidth');
        this._height = this._jCanvas.prop('naturalHeight');
        this._jCanvas
          .parent('.placeholder')
          .width(this._width)
          .height(this._height);

        d.resolve(this);
      });

      return d.promise();
    }

    /**
    * Перерисовать загруженные страницы.
    * 
    * @method Core.preview.actions._redrawKnownPages
    * @since 5.8.1.9000
    */
    _redrawKnownPages() {
      let d = $.Deferred();
      this.handleCurrentPage();
      const targetPage = this._jPageNumber.val();
      let allPages = this._jFrameContents.find('canvas').filter((index, page) => { return ((typeof $(page).attr('src') !== 'undefined') && $(page).attr('src') !== ''); });
      const totalPages = allPages.length;
      let pagesProcessed = 0;
      $.each(allPages, (index, page) => {
        Core.preview._drawImageInCanvas($(page).attr('data-pagenumber'), this._direction, this._scale, true).done(() => {
          pagesProcessed++;
          if (pagesProcessed === totalPages) {
            const targetHeight = this._jCanvas.height();
            const targetWidth = this._jCanvas.width();

            let jEmptyPages = this._jFrameContents.find('canvas').filter((index, page) => { return ((typeof $(page).attr('src') === 'undefined') || $(page).attr('src') === ''); });
            $.each(jEmptyPages, (index, page) => {
              page.height = targetHeight;
              page.width = targetWidth;
            });

            this.jumpToPage(targetPage);
            
            Core.preview.dispatchFrameReadyEvent();

            d.resolve();
          }
        });
      });

      return d.promise();
    }

    /**
     * После загрузки фрейма наполняем его пустышками чтобы появилась
     * прокрутка необходимой высоты.
     * @function Core.preview.scrolling.fillWithPlaceHolders
     * @return {Core.preview.scrolling}
     * @since 5.1.0.1523
     */
    fillWithPlaceHolders() {
      let page = {
        id: this._pagesIterator,
        src: '',
      };

      const targetHeight = this._jCanvas.height();
      const targetWidth = this._jCanvas.width();

      const html = `<div class="placeholder"> 
                      <canvas class="page invisible"></canvas>
                    </div>`;

      const tmpHtml = $('<div></div>');
      while (this._pagesIterator <= this._pageCount) {
        const jPlaceHolder = $(html);
        const jCanvas = jPlaceHolder.children().first();
        const pageNumber = this._pagesIterator;
        jPlaceHolder.attr('id', `placeholder_${pageNumber}`);
        jPlaceHolder.attr('data-pagenumber', pageNumber);
        jPlaceHolder.addClass('placeholder_spinner');

        jCanvas.attr('id', `page_${pageNumber}`);
        jCanvas.attr('data-pagenumber', pageNumber);
        jCanvas[0].height = targetHeight;
        jCanvas[0].width = targetWidth;

        if (WA.ENV.browser.name === 'IE') {
          jCanvas.parent('.placeholder').width(targetWidth).height(targetHeight);
        }
          
        tmpHtml.append(jPlaceHolder);
        this._pagesIterator++;
      }
      this._jFrameContents.find('body').append(tmpHtml.html());

      this._jPlaceholder = this._jFrameContents.find('.placeholder');
      return this;
    }

    /**
     * При перематывании страниц находим текущую страницу.
     *
     * @function Core.preview.scrolling.attachToFrameScrolling
     * @return {Core.preview.scrolling}
     * @since 5.1.0.1523
     */
    attachToFrameScrolling() {
      let scroller = $(this._jFrame.get(0).contentWindow);
      scroller.off('scroll touchmove').on('scroll touchmove', () => {
        if (this._isCallJumpToPage) {
          //Сбросим значение.
          this._isCallJumpToPage = false;
          this._actualizePages(this._data.selectedObj.pageNumber);
        } 

        this.handleCurrentPage();
      });

      return this;
    }

    /**
     * Поиск и выделение текущей страницы.
     *
     * @function Core.preview.scrolling.handleCurrentPage
     * @return {Core.preview.scrolling}
     * @since 5.1.0.1523
     */
    handleCurrentPage() {
      const contentWindow = this._jFrame[0].contentWindow;
      let documentElement = contentWindow.document;
      let jPage;
      let yScroll = contentWindow.scrollY || contentWindow.pageYOffset;

      if (yScroll === 0) {
        jPage = $('canvas', documentElement).first();
      } else if ((window.innerHeight + yScroll) >= contentWindow.document.body.offsetHeight) {
        jPage = $('canvas', documentElement).last();
      } else {
        const jFrameParent = this._jFrame.parent('div');
        let areaRect = [
          jFrameParent.width() * 0.5,
          jFrameParent.height() * (1 / 3),
        ];

        jPage = $(documentElement.elementFromPoint(...areaRect));
      }

      let jPlaceholder = jPage;
      let jCanvas = jPage;
      if (jPage.hasClass('placeholder')) {
        jCanvas = jPage.find('canvas');
      } else {
        jPlaceholder = jPage.parent('.placeholder');
      }
      this._jFrameContents.find('.placeholder').removeClass('current');
      if (jPlaceholder) {
        jPlaceholder.addClass('current');
      }
      if (jCanvas) {
        const id = jCanvas.data('pagenumber');

        this._actualizePages(id);
      }

      return this;
    }

    /**
     * Загрузка страницы и обработка загрузки.
     *
     * @function Core.preview.scrolling.loadPage
     * @param {number} pageNum номер страницы
     * @return {Deferred}
     * @since 5.1.0.1523
     */
    loadPage(pageNum) {
      let d = $.Deferred();
      Core.preview._drawImageInCanvas(pageNum, this._direction, this._scale).done(() => {
        let currPlaceholder = this._jFrameContents.find(`#placeholder_${pageNum}`);
        currPlaceholder.removeClass('placeholder_spinner');

        let jBody = $('body', this._jFrameContents);
        if (jBody) {
          let bodyWidth = jBody[0].style.width.replace(/[^-\d\.]/g, '') || jBody.width();
          if (currPlaceholder) {
            let placeholderWidth = currPlaceholder.width();

            if (bodyWidth < placeholderWidth) {
              jBody.css('width', placeholderWidth);
            }
          }
        }

        d.resolve();
      });
      return d.promise();
    }

    /**
    * Загрузить видимые страницы
    *
    * @method Core.preview.actions.loadVisiblePages
    * @since 5.8.1.9000
    */
    loadVisiblePages() {
      let currentPageNum = this._data.selectedObj.pageNumber || 1;
      this.loadPage(currentPageNum);

      let jLoadedPages = this._jFrameContents.find('canvas').filter((index, page) => { return $(page).attr('src') !== ''; });
      let lastLoadedPage = jLoadedPages[jLoadedPages.length - 1];

      const contentWindow = this._jFrame[0].contentWindow;
      let yScroll = contentWindow.scrollY || contentWindow.pageYOffset;

      if (lastLoadedPage) {
        let attrLastPageNum = lastLoadedPage.attributes['data-pagenumber'];
        if (attrLastPageNum) {
          let lastPageNum = parseInt(attrLastPageNum.value);
          if (lastPageNum < this._pageCount && lastLoadedPage.offsetTop < (yScroll + this._containerSize.height)) {
            this.loadPage(lastPageNum + 1).done(() => {
              this.loadVisiblePages();
            });
          }
        }
      }

      let jPrevNotLoadedPages = this._jFrameContents.find('canvas').filter((index, page) => { return !$(page).attr('src') && index <= currentPageNum; });
      let prevNotLoadedPage = jPrevNotLoadedPages[jPrevNotLoadedPages.length - 1];

      if (currentPageNum > 1 && prevNotLoadedPage && prevNotLoadedPage.offsetTop + prevNotLoadedPage.height > (yScroll - this._containerSize.height)) {
        let attrPrevNotLoadedPageNum = prevNotLoadedPage.attributes['data-pagenumber'];
        if (attrPrevNotLoadedPageNum) {
          let prevNotLoadedPageNum = parseInt(attrPrevNotLoadedPageNum.value);
          this.loadPage(prevNotLoadedPageNum).done(() => {
            this.loadVisiblePages();
          });
        }
      }
    }

    /**
     * Переход к указанной странице.
     *
     * @function Core.preview.scrolling.jumpToPage
     * @param {number} pageNum номер страницы
     * @return {Core.preview.scrolling}
     * @since 5.1.0.1523
     */
    jumpToPage(pageNum) {
      if (pageNum > this._pageCount) {
        pageNum = this._pageCount;
      } else if (pageNum < 1) {
        pageNum = 1;
      }

      this._isCallJumpToPage = true;
      this._data.selectedObj.pageNumber = pageNum;

      const offsetTop = this._jFrameContents.find('#page_' + pageNum).offset().top;
      this._jFrameContents.scrollTop(this._jFrameContents.find('#page_' + pageNum).offset().top);
    }

    /**
     * Перейти на предыдущую страницу.
     *
     * @method goToPreviousPage
     */
    goToPreviousPage() {
      this.jumpToPage(this._data.selectedObj.pageNumber - 1);
    }

    /**
     * Перейти на следующую страницу.
     *
     * @method goToNextPage
     */
    goToNextPage() {
      this.jumpToPage(this._data.selectedObj.pageNumber + 1);
    }

    /**
    * Пересчитать размеры контейнера изображения.
    *
    * @method _recalculateContainerSize
    * @private
    */
    _recalculateContainerSize() {
      const padding = this._placeholderMargin * 2;
        this._containerSize = {
          height: this._jFrame.height() - padding,
          width: this._jFrame.width() - padding,
        };
    }

    /**
    * @see Core.preview.BaseActions.setScale
    */
    setScale(key = this._settings.previewScale) {
      Core.preview._showOverlay();

      this._scaleKey = key;
      super.setScale(key);
      this._setScaleValueInDropdownAndButtons(key);
      this._scale = this._getScale(key);

      this._redrawKnownPages().always(() => {
        this.handleCurrentPage();
        setTimeout(() => {
          // Сработает после обработчика always
          Core.preview._hideOverlay();
        }, 0);
      });

      return this;
    }

    /**
     * @function Core.preview.actions._getScale
     * @param {any} key Способ масштабирования.
     * @return {number} Масштаб.
     */
    _getScale(key) {
      let initHeight = this._imageInitialSize.height;
      let initWidth = this._imageInitialSize.width;
      if (!(initHeight && initWidth)) {
        initHeight = this._jCanvas.prop('naturalHeight');
        initWidth = this._jCanvas.prop('naturalWidth');
      }

      return this._calculateScaleRelativeToContainer(initWidth, initHeight, key);
    }

    /**
     * @see Core.preview.ImageActions._rotatePages
     */
    _rotatePages(direction) {
      Core.preview._showOverlay();

      this._direction = direction;
      this._scale = this._getScale(this._scaleKey);

      this._redrawKnownPages().always(() => {
        Core.preview._hideOverlay();
      });

      let jPages = this._jFrameContents.find('canvas');
      $.each(jPages, (index, page) => {
        let jCurrentPage = $(jPages[index]);
        let placeholder = jCurrentPage.parent();
        placeholder
          .removeClass('N E W S')
          .addClass(direction);
      });
    }

    /**
   * Актуализация страниц.
   * @function Core.preview.scrolling._actualizePages
   * @param {int} pageNum Номер текущей страницы.
   * @since 5.6.2
   * @private    
   */
    _actualizePages(pageNum = this._jPageNumber.val()) {
      if ((pageNum && pageNum < 1) || !pageNum || isNaN(pageNum)) {
        pageNum = 1;
      }
      this._data.selectedObj.pageNumber = pageNum;
      this._jPageNumber.val(pageNum);
      this.loadVisiblePages();
    }

    /**
    * Установить размеры для html и body.
    * @function Core.preview.multipage-action._setSizesToHtmlAndBody
    * @param {string} key Масштаб.
    * @param {boolean} bodyWidth Размер тела документа.
    * @param {int} scale Масштаб в числовом значении.
    * @param {string} cssTransformOrigin Значение начальной точки трансформации.
    * @param {boolean} isNeedMargin Определяет нужен ли дополнительный отступ для картинки.
    * @since 5.8.0
    * @private    
    */
    _setSizesToHtmlAndBody(key, bodyWidth, scale, cssTransformOrigin, isNeedMargin = true) {
      if (key === 'w') {
        this._html.css({
          margin: '',
          transform: '',
          transformOrigin: '',
        });
        this._jFrame.contents().find('body').css({
          margin: (isNeedMargin ? '8px' : ''),
          width: bodyWidth,
          transform: `scale(${scale})`,
          transformOrigin: 'left top',
        });
      }
      else {
        // Изменить масштаб и указать отступы слева и справа, чтобы при изменении масштаба не появлялся горизонтальный скрол
        this._html.css({
          margin: '',
          transform: `scale(${scale})`,
          transformOrigin: cssTransformOrigin,
        });
        this._jFrame.contents().find('body').css({
          margin: '',
          transform: '',
          transformOrigin: '',
        });
      }
    }

    /**
    * Установить текущий масштаб в выпадайке масштаба и на кнопках масштабирования.
    *
    * @method _setScaleValueInDropdownAndButtons
    * @param {string} key Масштаб.
    * @private
    */
    _setScaleValueInDropdownAndButtons(key) {
      const isScaleAlreadySet = this._setScaleValueInDropdown(key);
      if (!isScaleAlreadySet) {
        $('.fit-to').removeClass('selected');
        const buttonKey = new Map([
          [PREVIEW_SCALE.FIT_HEIGHT, 'fitToHeight'],
          [PREVIEW_SCALE.FIT_WIDTH, 'fitToWidth'],
          [PREVIEW_SCALE.FIT_WINDOW, 'fitToWindow'],
        ]).get(key);
        if (buttonKey) {
          window.Core.preview.toolbar.buttons[buttonKey].turnOn();
        }
      }
    }

    /**
    * Установить масштаб относительно области предпросмотра.
    *
    * @method _calculateScaleRelativeToContainer
    * @param {string} initialWidth Начальная ширина.
    * @param {string} initialHeight Начальная высотаы.
    * @param {string} key Способ масштабирования (одно из значений PREVIEW_SCALE).
    * @private
    * @return {number} Масштаб.
    */
    _calculateScaleRelativeToContainer(initialWidth, initialHeight, key) {
      let scale;
      const shouldFlipHeightAndWidth = (this._direction === 'W' || this._direction === 'E');
      switch (key) {
        case PREVIEW_SCALE.FIT_HEIGHT: {
          const initSize = shouldFlipHeightAndWidth ? initialWidth : initialHeight;
          scale = this._containerSize.height / initSize;
          break;
        }
        case PREVIEW_SCALE.FIT_WIDTH: {
          const initSize = shouldFlipHeightAndWidth ? initialHeight : initialWidth;
          scale = this._containerSize.width / initSize;
          break;
        }
        case PREVIEW_SCALE.FIT_WINDOW: {
          scale = shouldFlipHeightAndWidth ?
            Math.min(this._containerSize.width / initialHeight, this._containerSize.height / initialWidth) :
            Math.min(this._containerSize.width / initialWidth, this._containerSize.height / initialHeight);
        }
      }
      return (+key) / 100 || scale;
    }

    /**
    * Повернуть страницы документа по часовой стрелке.
    *
    * @method rotateCW
    * @return {Core.preview.scrolling}
    */
    rotateCW() {
      this._rotatePages(Directions.next());
      return this;
    }

    /**
     * Повернуть страницы документа против часовой стрелки.@
     *
     * @method rotateCCW
     * @return {Core.preview.scrolling}
     */
    rotateCCW() {
      this._rotatePages(Directions.prev());
      return this;
    }

    /**
     * @see BaseActions.printDocFromPreview
     */
    printDocFromPreview() {
      const tmpWindow = window.open('', 'PRINT', '');
      const contentDoc = $('#contentContainer').get(0).contentDocument;
      const spinnerText = L("PREPEARING_DOC_FOR_PRINT");

      const pages = $('.placeholder', contentDoc).get();

      let allPages = [];
      let pageNum = 1;
      let pagesLoaded = 0;
      let customBody = '';

      let customHTML = `
                <html lang="ru">
                  <head>
                    <link rel="stylesheet" type="text/css" href="/css/preview_print.css" />
                    <link rel="stylesheet" type="text/css" href="/css/wait-page.css" />
                    <script type="text/javascript">
                      function scriptOnLoad(){
                        var spinnerDiv = document.getElementsByClassName('spinner-container')[0]; 
                        spinnerDiv.parentNode.removeChild(spinnerDiv);
                        var pages = document.getElementsByTagName('img'); 
                        for (var i = 0; i < pages.length; i++) { 
                          pages[i].style.opacity = 1; 
                        }
                        window.print();
                        ${!this._isIpad && !WA.ENV.isAndroid() ? 'window.close();' : ''}
                      }
                    </script>
                  </head>
                  <body onload="scriptOnLoad(); ">
                    <div class="spinner-container">
                      <div class="spinner">
                        <img class="spinner__ring" src="../svg/WillNotBeBaked/pic-loading-ring.svg" alt="">
                        <img class="spinner__logo" src="../svg/WillNotBeBaked/pic-logo.svg" alt="">
                        <span class="spinner__text">&nbsp;${spinnerText}...</span> 
                      </div> 
                    </div>
                  </body>
                </html>`;

      tmpWindow.document.write(customHTML);

      pages.forEach((page) => {
        const jCanvas = $('canvas', page).get();
        jCanvas.forEach(() => {
          let downloadingImage = new Image();
          downloadingImage.onload = function () {
            const me = this;

            me.style = 'height: 100%; width: 100%; object-fit: contain; overflow: hidden;';
            allPages[me.id] = `<div style='page-break-after: always; height: 100%; width: 100%;'>${me.outerHTML}</div>`;
            pagesLoaded++;

            if (pagesLoaded === pages.length) {
              allPages.forEach((printPage) => {
                customBody += printPage;
              });

              tmpWindow.document.body.insertAdjacentHTML('beforeEnd', customBody);
              tmpWindow.document.close();

            }
          }
          downloadingImage.src = `${Core.preview.actions._data.previewHandlerUrl}/${Core.preview.actions._data.convertedObj.id}/${pageNum}`;
          downloadingImage.id = pageNum;
          pageNum++;
        });
      });
    }
  }

  global.ImageActions = ImageActions;
})(window.Core.preview);